import request from '@/utils/request'
import { CheckAccount } from "@/layout/components/metaMaskInit/accountHandler.js"
export const marginList = (data) => {
  return request({
    url: '/api/unit/expenseList',
    method: 'get',
    params:data,
  })
}



//volumeAudit
export const produceList = (data) => {
  return request({
    url: '/api/productionData/list',
    method: 'get',
    params:data,
  })
}

// /tat/list
export const tatList = (data) => {
  return request({
    url: '/api/producer/tatRecords',
    method: 'get',
    params:data,
  })
}
